import TelegramIcon from '@ucheba/ui/icons/icon__telegram-filled.svg'
import VkIcon from '@ucheba/ui/icons/icon__vk_square.svg'
import InstagramIcon from '@ucheba/ui/icons/icon__instagram_square.svg'
import WhatsappIcon from '@ucheba/ui/icons/icon__whatsapp-filled.svg'
import FacebookIcon from '@ucheba/ui/icons/icon__fb_circle.svg'
import YoutubeIcon from '@ucheba/ui/icons/icon__youtube-filled.svg'
import TwitterIcon from '@ucheba/ui/icons/icon__tw_circle.svg'
import OkIcon from '@ucheba/ui/icons/icon__odnoklassniki_square.svg'

export const SOCIAL_ICONS = {
  whatsapp: WhatsappIcon,
  telegram: TelegramIcon,
  vk: VkIcon,
  youtube: YoutubeIcon,
  facebook: FacebookIcon,
  instagram: InstagramIcon,
  twitter: TwitterIcon,
  odnoklassniki: OkIcon,
}
